/**
 * Delivery & Return Popup Handler
 * Save as: assets/delivery-return-popup.js
 */

class DeliveryReturnPopup {
  constructor() {
    this.popup = document.getElementById('deliveryReturnPopup');
    if (!this.popup) return;

    this.openButton = document.querySelector('[data-delivery-return-popup]');
    this.closeButton = this.popup.querySelector('[data-popup-close]');
    this.overlay = this.popup.querySelector('[data-popup-overlay]');
    
    this.init();
  }

  init() {
    // Open popup
    if (this.openButton) {
      this.openButton.addEventListener('click', () => this.open());
    }

    // Close popup
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }

    // Close on overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup.classList.contains('is-active')) {
        this.close();
      }
    });

    // Prevent body scroll when popup is open
    this.preventBodyScroll();
  }

  open() {
    this.popup.classList.add('is-active');
    this.popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    
    // Focus trap
    this.trapFocus();
  }

  close() {
    this.popup.classList.remove('is-active');
    setTimeout(() => {
      this.popup.style.display = 'none';
    }, 300); // Match animation duration
    document.body.style.overflow = '';
  }

  preventBodyScroll() {
    const popupContent = this.popup.querySelector('.m-popup-content');
    if (!popupContent) return;

    popupContent.addEventListener('touchmove', (e) => {
      const target = e.target;
      const scrollable = target.closest('.m-popup-content');
      
      if (!scrollable) {
        e.preventDefault();
      }
    }, { passive: false });
  }

  trapFocus() {
    const focusableElements = this.popup.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    // Focus first element
    firstElement.focus();

    // Trap focus
    this.popup.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new DeliveryReturnPopup();
  });
} else {
  new DeliveryReturnPopup();
}

// Reinitialize on Shopify section load
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new DeliveryReturnPopup();
  });
}